import { type VariantProps } from 'class-variance-authority';
import { type ComponentProps } from 'react';

import { cx } from '@/lib/cx';

import { estiloBadge } from './estilos';

export function Badge({
  tom,
  className,
  ...props
}: ComponentProps<'span'> & VariantProps<typeof estiloBadge>) {
  return <span className={cx(estiloBadge({ tom }), className)} {...props} />;
}
